import React from 'react';
import './PageTemplate.scss';

type PageTemplate = {
  header?: JSX.Element;
  children: React.ReactNode;
  footer?: JSX.Element;
};

const PageTemplate = ({ header, children, footer }: PageTemplate) => {
  return (
    <div className='PageTemplate'>
      {header}
      <main>{children}</main>
      {footer}
    </div>
  );
};

export default PageTemplate;
